import React, { useEffect, useState } from 'react'
import Services from './subCmponents/services'
import LucideIcon from './lucideIcon'

export default function Tools() {

  let [find, setFind] = useState("");

  let allServices = [
    {name:"ImageGen AI", comment:"Turn your ideas into images using AI.Enter a prompt and let our AI generate stunning visuals in seconds.",btn:"Create Now",link:"imageGenerator",image:"Sparkles"},
    { name: "AI Quiz Generator", comment: "Generate personalized MCQ quizzes from your study topics using AI. Test your knowledge and get instant feedback.", btn: "Try Now", link: "KnowledgeCheck", image: "CircleHelp" },
    {name:"AI Paraphrasing Tool", comment:"Our free AI Paraphrasing Tool helps you reword text into different styles while keeping the original meaning intact.", btn:"Try Now", link:"ParapharaseAI", image:"PenLine"},
    {name:"AI Grammer Fixer", comment:"Fix grammar, punctuation, and spelling errors instantly with our free AI Grammar Fixer.", btn:"Fix Now", link:"GrammarFixerAI", image:"SpellCheck"},
    { name: "QR Code Generator", comment: "Create custom QR codes for URLs, contact info, WiFi access and more in seconds.", btn: "Generate Now", link: "qr", image: "QrCode" },
    { name: "Word And Character Counter", comment: "Free online word counter and character counter tool. Count words, characters, sentences, and paragraphs instantly.", btn: "Count Now", link: "Counter", image: "FileText" },
    { name: "YouTube Thumbnail Downloader", comment: "Download the thumbnail images of any YouTube video quickly and effortlessly.", btn: "Download Now", link: "youtube-thumbnail-downloader", image: "Download" },
    { name: "Pk Dex Tracker", comment: "Easily track Daraz and AliExpress orders using PK-DEX tracking. Get real-time updates and manage deliveries hassle-free.", btn: "Track Now", link: "pkdex", image: "ListPlus" },
    { name: "Barcode Scanner", comment: "Scan any barcode instantly using your device's camera. No app installation needed.", btn: "Scan Now", link: "barcodeScan", image: "Barcode" },
    { name: "File Converter", comment: "Convert between PDF, Word, Excel, JPG, PNG and other formats quickly and securely.", btn: "Convert Now", link: "FileConverter", image: "ArrowRightLeft" },
    { name: "Free Text to Speech Converter", comment: "Convert any text into natural-sounding speech. Download as MP3 or WAV.", btn: "Convert Now", link: "Text-to-Speech-Converter", image: "Mic" },
    // {name:"checker", comment:"its for checcking", btn:"check Now", link:`/tool/1`,image:"SpellCheck"}
  ]

  const filterServices = allServices.filter(service =>
    service.name.toLowerCase().includes(find.toLowerCase())
  )
  let x=filterServices.length;

  return (
    <div className="allTools">
      <div className="popular" id='features'>
        <h1>Our Tools – Built by Tooliso</h1>
        <p>We don’t just build software for others — we build it for ourselves. Our toolstack proves what we’re capable of:</p>
        <input type="text" placeholder='Search tools...' value={find} onChange={(e) => setFind(e.target.value)} />
      </div>
      <div className="completeTools">
        {
          filterServices.map((singleService) => {
            return (
              <Services name={singleService.name} comment={singleService.comment} link={singleService.link} image={singleService.image} btn={singleService.btn} length={x}/>
            )
          })
        }
      </div>
      <div style={{height:"100px"}}></div>
    </div>
  )
}
